const MAP_ROUTE = "map";
export const KNOWN_SUBPATHS = [
    /^(\/expose\/[A-Za-z\d-]+)\/?/,
    /^(\/cdp-preview\/[A-Za-z\d-]+)\/?/,
    /^(\/wl-cdp\/[A-Za-z\d-]+)\/?/,
    /^(\/projekte\/expose\/[A-Za-z\d-]+)\/?/,
    /^(\/projekte\/expose-preview\/[A-Za-z\d-]+)\/?/,
    /^(\/annonces\/(?:[A-Za-z\d-]+\/){3,5}[A-Za-z\d-]+\.htm)\/?/,
    /^(\/detail\/[A-Za-z\d-]+\.htm)\/?/,
    /(\/detail-vente-[A-Za-z\d-]+\.htm)\/?/,
    /(\/detail-location-\d+-[A-Za-z\d-]+\.htm)\/?/,
    /^(\/[A-Za-z\d-]+\/detail.htm)\/?/,
];
// add every new route in CLIENT_ROUTES
export const CLIENT_ROUTES = {
    MAP: MAP_ROUTE,
};
